import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { differenceInMilliseconds, intervalToDuration } from 'date-fns'

@Pipe({
  name: 'remainingTime',
  standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class RemainingTimePipe implements PipeTransform {
  public constructor(
    private readonly translateService: TranslateService,
  ) {}

  public transform(referenceAt: string, compareAt: string): string {
    if (!referenceAt || !compareAt) {
      return ''
    }

    const compareDate = new Date(compareAt)
    const referenceDate = new Date(referenceAt)

    const milliseconds = differenceInMilliseconds(compareDate, referenceDate)
    const { days, hours, minutes } = intervalToDuration({ start: 0, end: milliseconds })

    const remaining = []
    if (days) {
      remaining.push(`${days} ${days > 1
        ? this.translateService.instant('PIPES.REMAINING_TIME.DAYS')
        : this.translateService.instant('PIPES.REMAINING_TIME.DAY')
        }`)
    }

    if (hours) {
      remaining.push(`${hours} ${hours > 1
        ? this.translateService.instant('PIPES.REMAINING_TIME.HOURS')
        : this.translateService.instant('PIPES.REMAINING_TIME.HOUR')
        }`)
    }

    if (minutes) {
      remaining.push(`${minutes} ${minutes > 1
        ? this.translateService.instant('PIPES.REMAINING_TIME.MINUTES')
        : this.translateService.instant('PIPES.REMAINING_TIME.MINUTE')
        }`)
    }

    if (remaining.length > 1) {
      const lastPart = remaining.pop()
      return `${remaining.join(', ')} ${this.translateService.instant('PIPES.REMAINING_TIME.AND')} ${lastPart}`
    }

    return remaining[0]
  }
}
